import { AngularMaterialModule } from './../shared/module/angular-material.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LanguagePickerModule } from '../shared/language-picker/language-picker.module';
import { NotificationsComponent } from '../notifications/notifications.component';
import { MatBadgeModule } from '@angular/material/badge';
import { ApplicationPipesModule } from '../shared/module/applicationPipesModule';
import { NavDrawerComponent } from './nav-drawer/nav-drawer.component';
import { TenantSwitcherComponent } from './tenant-switcher/tenant-switcher.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    AngularMaterialModule,
    MatFormFieldModule,
    MatInputModule,
    LanguagePickerModule,
    MatBadgeModule,
    ApplicationPipesModule
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    NotificationsComponent,
    SidebarComponent,
    NavDrawerComponent,
    TenantSwitcherComponent
  ],
  declarations: [
    FooterComponent,
    HeaderComponent,
    NotificationsComponent,
    SidebarComponent,
    NavDrawerComponent,
    TenantSwitcherComponent
  ]
})
export class LayoutModule { }
